var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-root" }, [
    _c(
      "ul",
      [
        _c("li", { class: { active: _vm.char == _vm.filterkey } }, [
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  _vm.filterkey = ""
                  _vm.mode = "list"
                },
              },
            },
            [_vm._v("Alle")]
          ),
        ]),
        _vm._v(" "),
        _vm._l(_vm.letters, function (char) {
          return _c("li", { class: { active: char == _vm.filterkey } }, [
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    _vm.filterkey = char
                    _vm.mode = "list"
                  },
                },
              },
              [_vm._v(_vm._s(char))]
            ),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.mode == "single"
      ? _c(
          "div",
          { staticClass: "glossary_messages" },
          _vm._l(_vm.singleItem, function (item) {
            return _c("div", { staticClass: "detail" }, [
              _c("h3", [_vm._v(_vm._s(item.title))]),
              _vm._v(" "),
              _c("div", {
                staticClass: "text",
                domProps: { innerHTML: _vm._s(item.description) },
              }),
            ])
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "glossary_messages" },
          [
            _vm.filterkey == ""
              ? _vm._l(_vm.glossaries, function (item) {
                  return _c("div", { staticClass: "item" }, [
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.loadItem(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                  ])
                })
              : [
                  _vm._l(_vm.glossarFiltered, function (item) {
                    return _c("div", { staticClass: "item" }, [
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadItem(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.title))]
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.glossarFiltered.length == 0
                    ? _c("div", { staticClass: "item" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.t("general.noentry")) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ],
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }